// fbuild test kuv-f-toherba-dev
export const environment = {
  production: false,
  envName: 'test',
  title: 'Production Environment Heading',
  webURL: 'https://kuvesoft.xyz/',
  apiURL: 'https://kuvesoft.xyz:4040/',
  kPagosURL: 'https://kpagos.kuvesoft.xyz/',
  habilitarSuscripciones: true,
  version: '6.2.0'
};
